import { useContext } from 'react'
import { User } from '../../types/user-types'
import { UserContext } from '../state/user-state'

export default function useUser(): { user: User | null; isLoading: boolean } {
  const { state: user, isLoading } = useContext(UserContext)
  return { user, isLoading }
}
